import WavingHandIcon from "@mui/icons-material/WavingHand"
import { Box, Stack, Typography } from "@mui/material"
import { ReactElement } from "react"
import { useNavigate } from "react-router-dom"

import { useScreenSize } from "../../hooks/useScreenSize"
import { BASE_URL } from "../../router/routes"
import AppButton from "../buttons/appButton"

/**
 * Sign out success component
 * @returns {ReactElement} React component
 */
const SignOutSuccess = (): ReactElement => {
    const { isMob } = useScreenSize()
    const navigate = useNavigate()
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            marginTop={7}
        >
            <Stack
                spacing={6}
                alignItems="center"
                width={isMob ? "95%" : "42%"}
            >
                <WavingHandIcon
                    sx={{ fontSize: { xs: "150px", sm: "200px" } }}
                    color="success"
                />
                <Typography
                    color="text.primary"
                    variant="h3"
                    fontWeight="500"
                    align="center"
                >
                    Successfully Signed Out
                </Typography>
                <Typography
                    variant="h5"
                    align="center"
                    fontWeight="300"
                    color="text.primary"
                >
                    You have been successfully signed out of your account.
                    Thanks for using ENA Connect Direct. See you again soon!
                </Typography>
                <AppButton
                    variant="contained"
                    onClick={() => navigate(BASE_URL)}
                    color="success"
                >
                    Return to Homepage
                </AppButton>
            </Stack>
        </Box>
    )
}

export default SignOutSuccess
